module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_01-f0afd405db7640854401c42f4a1f507f.png";